/** 선택 상태 : 기본, 정답, 오답 */
export type SelectStatusType = 'default' | 'correct' | 'wrong';

export interface Ranking {
  GameId: string;
  Score: number;
  Timestamp: string;
  UserId: string;
}

export interface Game {
  keyword: string;
  monthly_search_count: number;
}

export interface BlogPosting {
  CategoryPublicName: string;
  ThmubnailUrl: string;
  Title: string;
  Url: string;
}

export type ApiStatusType = 'loading' | 'success' | 'error';

export interface PersonalData {
  Timestamp: string;
  UserId: string;
  Score: number;
  GameId: string;
  Rank: number;
}

export const PersonalDataInitial: PersonalData = {
  Timestamp: '',
  UserId: '',
  Score: 0,
  GameId: '',
  Rank: 0,
};

/**
 * id : 디폴트 메시지 0, 생성된 메시지 Date.now() + 1
 * text : 메시지 텍스트
 * sender : user, bot 여부
 * subText : 생성된 고려요소
 * list : 생성된 키워드
 * remainCount : 동일 검색어에 대한 호출 가능 잔여 횟수
 * sessionId : 세션 아이디
 */
export interface Message {
  id: number;
  text: string;
  sender: 'user' | 'bot' | 'alert';
  subText?: string;
  list?: Array<string>;
  remainCount?: number;
  sessionId?: string;
  maxQuestionCount?: number;
  questionRemainCount?: number;
  action?: string | undefined;
  errorCode?: number;

  // thumbsUp?: boolean;
  // thumbsDown?: boolean;
}

export interface ProductName {
  product_name: string;
  Consideration?: string;
  Keywords?: Array<string>;
}
